import React from 'react';

const HeartRate = () => {
  return (
    <div className="w-[150px] h-[73px] relative mx-auto my-5">
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="150px"
        height="73px"
        viewBox="0 0 150 73"
        enableBackground="new 0 0 150 73"
        xmlSpace="preserve"
      >
        <polyline
          fill="none"
          stroke="#FF0000"
          strokeWidth="3"
          strokeMiterlimit="10"
          points="0,45.486 38.514,45.486 44.595,33.324 50.676,45.486 57.771,45.486 62.838,55.622 71.959,9 80.067,63.729 84.122,45.486 97.297,45.486 103.379,40.419 110.473,45.486 150,45.486"
        />
      </svg>

      <style jsx>{`
        @keyframes heartRateIn {
          0% { width: 100%; }
          50% { width: 0; }
          100% { width: 0; }
        }
        @keyframes heartRateOut {
          0% { left: -120%; }
          30% { left: -120%; }
          100% { left: 0; }
        }
      `}</style>

      <div 
        className="absolute w-full h-full bg-black top-0 right-0"
        style={{ animation: 'heartRateIn 3.5s linear infinite' }}
      />
      <div 
        className="absolute w-[120%] h-full top-0 -left-[120%]"
        style={{
          animation: 'heartRateOut 3.5s linear infinite',
          background: 'linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 80%, rgba(255, 255, 255, 0) 100%)'
        }}
      />
    </div>
  );
};

export default HeartRate;